import { createContext, useState } from "react";

export const TeamScheduleAdminPendingRoutineCreatedContext = createContext<{
  pendingRoutineCreated: string | null;
  setPendingRoutineCreated: React.Dispatch<React.SetStateAction<string | null>>;
}>({
  pendingRoutineCreated: null,
  setPendingRoutineCreated: () => {},
});

export function TeamScheduleAdminPendingRoutineCreatedProvider(props: {
  children: React.ReactNode;
}) {
  const [pendingRoutineCreated, setPendingRoutineCreated] = useState<
    string | null
  >(null);

  return (
    <TeamScheduleAdminPendingRoutineCreatedContext.Provider
      value={{
        pendingRoutineCreated,
        setPendingRoutineCreated,
      }}
    >
      {props.children}
    </TeamScheduleAdminPendingRoutineCreatedContext.Provider>
  );
}
